<div id="footer-container">
    <a routerLink="/kontakt">Kontakt</a>
    ·
    <a routerLink="/impressum" >Impressum</a>
    ·
    <a routerLink="/datenschutz">Datenschutzerklärung</a>
</div>
